<template>
  <div>
    <div class="d-flex justify-space-between mb-2">
      <div class="d-flex justify-center align-center">
        <div class="img_title_addtopping_manage_food">
          <img src="@/assets/seasoning.png">
        </div>
        <h2 class="title_addtopping_manage_food">เพิ่มท็อปปิ้ง</h2>
      </div>
      <v-btn class="grad-primary-bg white--text" height="50" width="20%" @click="$router.push('/managefood')">
        ย้อนกลับ
      </v-btn>
    </div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-if="loading_page === false">
      <v-card>
        <v-container>
          <v-form ref="form" @submit.prevent="addTopping()">
            <v-row>
              <v-col cols="12">
                <v-text-field label="ชื่อท็อปปิ้ง" :rules="[v => !!v || 'กรุณากรอกชื่อท็อปปิ้ง']" v-model="topingcategory" hide-details="auto" required outlined></v-text-field>
              </v-col>
              <v-col cols="12">
                <div>ลูกค้าจำเป็นต้องเลือก</div>
                <v-radio-group class="mt-0" v-model="select" hide-details="auto">
                  <div class="d-flex">
                    <div class="d-flex check_type_addtopping_manage_food">
                      <v-radio color="primary" value="essential"></v-radio>
                      <div>จำเป็น</div>
                    </div>
                    <div class="d-flex check_type_addtopping_manage_food">
                      <v-radio color="primary" value="not_essential"></v-radio>
                      <div>ไม่จำเป็น</div>
                    </div>
                  </div>
                </v-radio-group>
              </v-col>
              <v-col cols="12">
                <div>ลูกค้าสามารถเลือกได้หลายท็อปปิ้ง</div>
                <v-radio-group class="mt-0" v-model="selectlimit" hide-details="auto">
                  <div class="d-flex">
                    <div class="d-flex check_type_addtopping_manage_food">
                      <v-radio color="primary" hide-details="auto" value="not_limit"></v-radio>
                      <div>เลือกได้ไม่จำกัด</div>
                    </div>
                    <div class="d-flex check_type_addtopping_manage_food">
                      <v-radio color="primary" hide-details="auto" value="not_more_than"></v-radio>
                      <div class="mr-2">สูงสุด</div>
                      <div class="d-flex check_type_addtopping_manage_food">
                        <div class="d-flex align-center">
                          <div @click="addNumLimit('minus')" class="cursor_addtopping_manage_food">
                            <v-icon size="40">mdi-minus-circle</v-icon>
                          </div>
                          <div class="ml-2 mr-2">
                            {{ add_num_limit }}
                          </div>
                          <div @click="addNumLimit('plus')" class="cursor_addtopping_manage_food">
                            <v-icon size="40">mdi-plus-circle</v-icon>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                  <div class="d-flex">
                    <div class="d-flex check_type_addtopping_manage_food">
                      <v-radio color="primary" hide-details="auto" value="type_amount"></v-radio>
                      <div>เลือกแบบใส่จำนวน</div>
                    </div>
                  </div>
                </v-radio-group>

              </v-col>
              <v-col cols="12">
                <div>ช้อยส์</div>
                <v-card class="mb-2" v-for="(choice_detail,key) in choice_list" :key="key">
                  <div class="pa-2 d-flex justify-space-between">
                    <div>
                        <div>{{ choice_detail.name }}</div>
                        <div class="error--text" v-if="choice_detail.food_bom_list.length > 0">การผูกสูตรอาหาร</div>
                        <div class="error--text" v-for="(food_bom_detail,key_food_bom) in choice_detail.food_bom_list" :key="key_food_bom">
                          - {{ food_bom_detail.name }} {{ food_bom_detail.use_in }} {{ food_bom_detail.unit_name }}
                        </div>
                    </div>
                    <div class="d-flex">
                      <div class="border_choice_addtopping_manage_food d-flex justify-center align-center">{{ choice_detail.price }} ฿</div>
                      <v-icon color="error" @click="removeChoice(choice_detail.no)">mdi-close</v-icon>
                    </div>

                  </div>
                </v-card>
                <v-btn width="100%" @click="openAddChoice()">
                  <v-icon>mdi-plus</v-icon> เพิ่มช้อยส์
                </v-btn>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4"></v-col>
              <v-col cols="4">
                <v-btn color="#28ab28" class="white--text titlefont_addtopping_manage_food" type="submit" height="50" width="100%">
                  บันทึก
                </v-btn>
              </v-col>
              <v-col cols="4"></v-col>
            </v-row>
          </v-form>
        </v-container>
        <v-dialog v-model="open_add_choice" persistent max-width="900px">
          <v-card>
            <v-form ref="form_choice" @submit.prevent="addChoice()">
              <v-card-title>
                <div class="d-flex">
                  <v-icon>mdi-plus</v-icon> เพิ่มช้อยส์
                </div>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field label="ชื่อช้อยส์" :rules="[v => !!v || 'กรุณากรอกชื่อช้อยส์']" v-model="add_choice_name" required outlined></v-text-field>
                      <div>
                        เลือกช้อยส์นี้มีการเปลี่ยนแปลงอย่างไรกับเมนู
                      </div>
                      <v-radio-group class="mt-0" v-model="choice_price">
                        <div class="d-flex flex-column">
                          <div class="d-flex">
                            <v-radio color="primary" value="not_price"></v-radio>
                            <div>ไม่เปลี่ยนแปลง</div>
                          </div>
                          <div class="d-flex">
                            <v-radio color="primary" value="price"></v-radio>
                            <div>ราคาเพิ่มขึ้น</div>
                          </div>
                        </div>
                      </v-radio-group>

                      <v-text-field label="บาท" :rules="[v => !!v || 'กรุณากรอกราคาที่เพิ่มขึ้น']" v-model="price" type="number" outlined v-if="choice_price === 'price'" required></v-text-field>

                    </v-col>
                  </v-row>
                  <v-row class="mt-3">
                    <v-col cols="12">
                      <div class="d-flex">
                        <div class="pr-2" style="font-size: 18px !important"><b>การผูกสูตรอาหาร</b></div>
                        <div class="grey--text" style="font-size: 18px !important">(สามารถเพิ่มได้หลายวัตถุดิบ)</div>
                      </div>
                    </v-col>
                    <v-col cols="12">
                      <div class="mt-n1 mr-1">
                        <v-autocomplete :items="list_menu" item-text="name" item-value="id" @input="add_material(material_id)" v-model="material_id" prepend-inner-icon="mdi-magnify" label="เลือกวัตถุดิบ" hide-details="auto" outlined></v-autocomplete>
                      </div>
                    </v-col>
                    <v-col>
                      <div>
                        <v-data-table :headers="material_header" :items="data_list" :items-per-page="-1" mobile-breakpoint="0" hide-default-footer>
                          <template slot="item" slot-scope="dataDetail">
                            <tr class="text-center">
                              <td>
                                <v-btn color="red" small height="42" class="white--text mb-1" @click="getDelete(dataDetail.item.loop_id)">
                                  <v-icon>mdi-window-close</v-icon>
                                </v-btn>
                              </td>
                              <td>{{ dataDetail.item.name }}</td>
                              <td class="pa-3">
                                <v-text-field type="number" min="0" :rules="[v => !!v || 'กรุณากรอกจำนวน']" @keypress="onlyForCurrency($event, dataDetail.item.material_input)" v-model="dataDetail.item.material_input" hide-details="auto" outlined></v-text-field>
                              </td>
                              <td>{{ dataDetail.item.unit_name }}</td>
                            </tr>
                          </template>
                        </v-data-table>
                        <v-divider/>
                      </div>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-spacer></v-spacer>
              <div class="text-center pa-4">
                <v-btn color="#28ab28" class="white--text ma-2" type="submit" height="50">
                  บันทึก
                </v-btn>
                <v-btn color="error" class="ma-2" type="button" height="50" @click="open_add_choice = false">
                  ยกเลิก
                </v-btn>
              </div>
            </v-form>
          </v-card>
        </v-dialog>
      </v-card>
    </div>
    <v-dialog v-model="alert_show_add" persistent max-width="600">
      <v-card>
        <v-card-title>
          สำเร็จ
        </v-card-title>

        <v-card-text>
          เพิ่มท็อปปิ้งเรียบร้อย
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#28ab28" text @click="confirmSuccess()">
            ตกลง
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script src="@/previewimage.js"></script><script>
import {
  HTTP
} from "@/axios.js"
export default {
  name: 'addTopping',
  data() {
    return {
      loading_page: false,
      add_num_limit: 1,
      open_add_choice: false,
      topingcategory: null,
      select: "essential",
      selectlimit: "not_limit",
      choice_list: [],
      no: 0,
      add_choice_name: null,
      choice_price: 'not_price',
      price: null,
      alert_show_add: false,
      list_menu_default: [],
      list_menu: [],
      material_id: null,
      material_header: [
        {
          text: '',
          value: '',
          sortable: false,
          fixed: true,
          width: '150px',
          align: 'center',
        },
        {
          text: 'วัตถุดิบ',
          value: '',
          sortable: false,
          fixed: true,
          width: '250px',
          align: 'center',
        },
        {
          text: 'จำนวน',
          value: '',
          sortable: false,
          fixed: true,
          width: '200px',
          align: 'center',
        },
        {
          text: 'หน่วยนับ',
          value: '',
          sortable: false,
          fixed: true,
          width: '200px',
          align: 'center',
        },
      ],
      data_list: [],
      loop_id: 0,
    }
  },
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  methods: {
    onlyForCurrency(evt, number) {
      evt = (evt) ? evt : window.event;
      let charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();
      }
      // restrict to 2 decimal places
      else if (number !== null && number.indexOf(".") > -1 && (number.split('.')[1].length >= 2)) {
        evt.preventDefault();
      } else {
        return true
      }
    },
    async addNumLimit(type) {
      if (type === 'plus') {
        this.add_num_limit += 1
      }
      if (type === 'minus' && this.add_num_limit > 1) {
        this.add_num_limit -= 1
      }
    },
    async openAddChoice() {
      this.open_add_choice = true
      this.add_choice_name = null
      this.choice_price = 'not_price'
      this.price = null
      this.list_menu = this.list_menu_default
      this.data_list = []
    },
    async receipt() {
      HTTP.get('/bom/searchMat', {
        headers: {
          "Authorization": `Bearer ${this.$store.state.token}`
        }
      }).then((response) => {
        if (response.data.successful === true) {
          this.list_menu_default = response.data.mat
          this.list_menu = response.data.mat
        }
      }).catch((error) => {
        if (error.response.status === 401) {
          this.$store.commit('logOutSuccess')
          this.$router.push('/login')
        }
      })
    },
    async add_material(mat_id) {
      let value = this.list_menu.find((res) => {
        return res.id === mat_id
      })
      this.list_menu = this.list_menu.filter((res) => {
          return res.id != mat_id
      })

      let loop_id = this.loop_id += 1
      this.data_list.push({
        loop_id: loop_id,
        id: value.id,
        unit_id: value.unit_id,
        name: value.name,
        material_input: null,
        unit_name: value.unit_name,
      })

      await this.$nextTick(() => {
        this.material_id = null
      })
    },
    async getDelete(loop_id) {
      const value = this.data_list.find((detail) => {
        return detail.loop_id === loop_id
      })
      this.list_menu.push({
        id: value.id,
        name: value.name,
        unit_id: value.unit_id,
        unit_name: value.unit_name,
      })
      this.data_list = this.data_list.filter(detail => detail.loop_id != loop_id)
      this.list_menu.sort((a, b) => {
          let fa = a.name.toLowerCase(),
              fb = b.name.toLowerCase();

          if (fa < fb) {
              return -1;
          }
          if (fa > fb) {
              return 1;
          }
          return 0;
      })
      this.material_id = null
    },
    async addChoice() {
      if (this.$refs.form_choice.validate()) {
        this.open_add_choice = false
        let result_price = 0
        if (this.price > 0) {
          result_price = this.price
        }
        this.no += 1

        if (this.choice_price == 'not_price') {
          result_price = 0
        }
        let food_bom_list = []
        this.data_list.forEach(detail => {
            food_bom_list.push({
              id: detail.id,
              name: detail.name,
              use_in: detail.material_input,
              unit_id: detail.unit_id,
              unit_name: detail.unit_name,
            })
        })
        this.choice_list.push({
          no: this.no,
          name: this.add_choice_name.replace(this.$store.state.checkEmoji, ""),
          price: result_price,
          food_bom_list: food_bom_list,
        })
      }
    },
    async removeChoice(no) {
      this.choice_list = this.choice_list.filter(detail => detail.no != no)
    },
    async addTopping() {
      if (this.$refs.form.validate()) {
        this.loading_page = true
          let necessary = ''
          let notnecessary = ''
          let unlimit = ''
          let limit = ''
          let amount = ''
          let type_amount = ''

          if (this.select === 'essential') {
            necessary = 1
          }
          if (this.select === 'not_essential') {
            notnecessary = 1
          }

          if (this.selectlimit === 'not_limit') {
            unlimit = 1
          }
          if (this.selectlimit === 'not_more_than') {
            limit = 1
          }
          if (this.add_num_limit > 0) {
            amount = this.add_num_limit
          }
          if (this.selectlimit === 'type_amount') {
            type_amount = 1
          }

          HTTP.post('/toping/create', {
            topingcategory: this.topingcategory.replace(this.$store.state.checkEmoji, ""),
            necessary: necessary,
            notnecessary: notnecessary,
            unlimit: unlimit,
            limit: limit,
            amount: amount,
            type_amount:type_amount,
            choice_list: this.choice_list
          }, {
            headers: {
              "Authorization": `Bearer ${this.$store.state.token}`
            }
          }).then((response) => {
            if (response.data.successful === true) {
              this.alert_show_add = true
              this.loading_page = false
            }
          }).catch((error) => {
            if (error.response.status === 401) {
              this.$store.commit('logOutSuccess')
              this.$router.push('/login')
            }
          })
      }
    },
    async confirmSuccess() {
      this.$router.push('/managefood')
    }
  },
  mounted() {
    this.receipt()
  },
}
</script>
